import { HTTP_DELIVER_FETCHING, HTTP_DELIVER_SUCCESS, HTTP_DELIVER_FAILED } from '../constants';

const initialState = {
  result: null,
  isFatching: false,
  isError: false
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case HTTP_DELIVER_FETCHING:
      return { ...state, result: [], isFetching: true, isError: false };
    case HTTP_DELIVER_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    case HTTP_DELIVER_FAILED:
      return { ...state, result: [], isFetching: false, isError: true };

    default:
      return state;
  }
};
